export const ENGINE = {
  FIXED_DT: 1 / 60,
  TARGET_FPS: 60,
  MAX_FRAME_TIME: 0.25, // Prevent spiral of death if tab is backgrounded
} as const;

export const PADDLE = {
  DEFAULT_WIDTH: 0.25,
  WIDTH_2_LIVES: 0.18,
  WIDTH_1_LIFE: 0.11,
  INITIAL_LIVES: 3,
  
  // Acceleration and speed for human
  ACCEL_BASE: 0.004,
  MAX_SPEED_BASE: 0.03,
  FRICTION: 0.85,

  // Tilt deflection
  TILT_SPEED: 0.08,
  MAX_TILT: Math.PI / 4,
  TILT_RECOVERY: 0.80,

  // Smash mechanic
  SMASH_CHARGE_TIME_SEC: 20,
  SMASH_ACTIVE_TICKS: 45,
  SMASH_THRUST_DISTANCE: 40,
} as const;

export const BALL = {
  RADIUS: 8,
  INITIAL_SPEED: 7.5,
  MAX_SPEED: 22,
  BOUNCE_SPEED_MULTIPLIER: 1.02,
  
  // Sweet spot
  SWEET_SPOT_THRESHOLD: 0.05, // within 5% of paddle center
  SWEET_SPOT_SPEED_MULT: 1.3,

  // Smash
  SMASH_SPEED_MULT: 1.8,

  // Magnus spin physics
  MAGNUS_FORCE: 0.015,
  SPIN_DAMPING: 0.99,
  MAX_SPIN: 30,

  // Multiball temp ball lifespan
  TEMP_BALL_TICKS: 300,
} as const;

export const POWERUP = {
  SPAWN_INTERVAL_TICKS: 1500, // ~25 seconds
  LIFETIME_TICKS: 1200,       // ~20 seconds
  RADIUS: 16,
  SHIELD_DURATION_TICKS: 600, // 10 seconds
  EMP_DURATION_TICKS: 180,    // 3 seconds
  EMP_SPEED_MULT: 0.4,
} as const;

export const BLACK_HOLE = {
  STALL_HIT_THRESHOLD: 5,
  DURATION_TICKS: 600,
  RADIUS: 40,
  MAX_FORCE: 0.15,
} as const;

export const SCORES = {
  PADDLE_HIT: 10,
  SMASH_HIT: 50,
  SWEET_SPOT: 150,
  POWERUP_1UP: 200,
  POWERUP_MULTIBALL: 100,
  POWERUP_SHIELD: 100,
  POWERUP_EMP: 150,
  BOT_KILL: 500,
  SURVIVAL_BONUS: 500,
  CHAMPION_BONUS: 2000,
} as const;

export const STORAGE_KEYS = {
  HIGH_SCORES: 'polypong_high_scores_top10_v2',
  SETTINGS: 'polypong_settings_v2',
} as const;
